<template>
    <tr>
        <td>
            <router-link
                :to="{name: 'office.forms.edit', params: { id: form.id }}"
                title="Edit Form"
            >
                {{ form.doc_no }}
            </router-link>
        </td>
        <td>
            <router-link
                :to="{name: 'office.forms.edit', params: { id: form.id }}"
                title="Edit Form"
            >
                {{ form.nice_type }}
            </router-link>
        </td>
        <td>
            <div v-if="form.customer">
                <router-link :to="{name:'office.customers.show', params: { id: form.customer_id }}">
                    {{ form.customer.company_name }}
                </router-link>
            </div>
            <div v-if="!form.customer">
                -
            </div>
            <div v-if="form.site_id && form.site">
                {{ form.site.name }},
                <span v-if="form.site.address">
                    {{ form.site.address.town }}
                </span>
            </div>
        </td>
        <td>
            <span v-if="form.engineer">{{ form.engineer.name }}</span>
            <span v-else>-</span>
        </td>
        <td>
            <span
                class="p-1 rounded bg-success text-white"
                style="font-size: .9rem"
                v-if="form.type === 'recommendations' && form.is_complete"
            >Complete</span>
            <span
                class="p-1 rounded bg-light"
                style="font-size: .9rem"
                v-if="form.type === 'recommendations' && !form.is_complete"
            >Incomplete</span>
        </td>
        <td>
            <button
                @click="toggleNotes"
                :class="`toggle-notes-button ${!!invoiceNotes ? 'toggle-notes-button--alert' : ''}`"
            >
                Toggle Notes
            </button>
            <textarea
                rows="3"
                v-if="showNotes"
                v-model="invoiceNotes"
                placeholder="Add invoice notes here..."
                class="form-control"
                @blur="save"
            />
        </td>
        <td>
            {{ form.created_at.format('DD-MM-YYYY') }}
        </td>
        <td>
            <user-select
                :autoselect="false"
                :engineers="false"
                v-model="form.invoiced_by_id"
                @input="save"
            />
        </td>
        <td>
            <router-link
                :to="{name: 'office.forms.edit', params: { id: form.id }}"
                title="Edit Form"
            >
                <i class="fa fa-pencil-alt" />
            </router-link>
            <a
                v-if="form.id"
                :href="'/api/forms/' + form.id + '/stream'"
                title="Print Preview"
            >
                <i class="fa fa-print" />
            </a>

            <a
                v-if="form.id"
                :href="'/api/forms/' + form.id + '/download'"
                target="_blank"
                title="Download PDF"
            >
                <i class="fa fa-file" />
            </a>
            <router-link
                v-if="form.id"
                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                title="Send to Customer"
            >
                <i class="fa fa-envelope" />
            </router-link>
        </td>
    </tr>
</template>

<script>
import FormService from '../../services/FormService';
import UserSelect from '../UserSelectComponent.vue'

export default {
    component: {
        UserSelect,
    },
    props: {
        form: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            showNotes: false,
            invoiceNotes: '',
        };
    },
    watch: {
        form: {
            immediate: true,
            handler () {
                this.invoiceNotes = this.form.invoice_notes;
            }
        },
    },
    methods: {
        toggleNotes () {
            this.showNotes = !this.showNotes;
        },
        save () {
            this.invoiceNotes = this.invoiceNotes ? this.invoiceNotes.slice(0, 2000) : '';
            FormService.updateInvoice({id: this.form.id, invoice_notes: this.invoiceNotes, invoiced_by_id: this.form.invoiced_by_id}).then(res => {
                this.$emit('saved');
            }).catch(err => {
                window.alert('Error: Failed to save invoice notes');
                console.error(err);
            })
        }
    },
}
</script>
<style scoped lang="scss">
.toggle-notes-button {
    appearance: none;
    background: #c9c9c9;
    border: none;
    color: black;
    text-align: center;
    white-space: nowrap;
    border-radius: 3px;
    font-size: .9rem;

    &--alert {
        background: red;
        color: white !important;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/InvoiceableFormRow.vue